import Funnel from './Funnel';

export default Funnel;
